import { render, staticRenderFns } from "./choiceSorting.vue?vue&type=template&id=49948e52&scoped=true"
import script from "./choiceSorting.vue?vue&type=script&lang=js"
export * from "./choiceSorting.vue?vue&type=script&lang=js"
import style0 from "./choiceSorting.vue?vue&type=style&index=0&id=49948e52&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49948e52",
  null
  
)

export default component.exports